import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const ADMIN_APPROVAL_SERVER = ConfigurationService.get(
  ConfigurationKeys.ADMIN_APPROVAL_SERVER
);

export const ACCESS_MANAGEMENT = `${ADMIN_APPROVAL_SERVER}/rest/v1/identity-accesses`;
export const ACCESS_MANAGEMENT_NOTES = `${ADMIN_APPROVAL_SERVER}/rest/v1/identity-access-notes`;
